<template>
  <div class="create-index-layout">
    <div>
      <a-steps :current="currentStep">
        <a-step>
          <template slot="title">
            Select constituents
          </template>
        </a-step>
        <a-step>
          <template slot="title">
            Define inception date
          </template>
        </a-step>
        <a-step>
          <template slot="title">
            Create index
          </template>
        </a-step>
      </a-steps>
    </div>
    <div class="mx-10 my-4">
      <select-constituents
        v-show="currentStep === 0"
        @selectionChanged="onConstituentsSelectionChanged($event)"
      />
      <define-inception-date
        v-show="currentStep === 1"
        :constituents="constituentsForInceptionDate"
        @inceptionDateChanged="onInceptionDateChanged($event)"
      />
      <index-creation
        v-show="currentStep === 2"
        :inceptionYear="inceptionYear"
        :inceptionMonth="inceptionMonth"
        :constituents="selectedConstituents"
      />
    </div>
    <div>
      <a-button @click="goToPreviousStep()" v-show="!firstStep" class="mr-4">
        Back
      </a-button>
      <a-button
        type="primary"
        @click="goToNextStep()"
        v-show="!lastStep"
        :disabled="nextButtonDisabled"
        :title="
          nextButtonDisabled ? 'Please select at least 3 constituents' : ''
        "
      >
        Next
      </a-button>
    </div>
  </div>
</template>

<script>
import SelectConstituents from '../components/index/SelectConstituents.vue'
import DefineInceptionDate from '../components/index/DefineInceptionDate.vue'
import IndexCreation from '../components/index/IndexCreation.vue'

export default {
  components: {
    DefineInceptionDate,
    IndexCreation,
    SelectConstituents,
  },
  data() {
    return {
      currentStep: 0,
      selectedConstituents: [],
      constituentsForInceptionDate: [],
      inceptionYear: 0,
      inceptionMonth: 0,
    }
  },
  methods: {
    goToNextStep() {
      if (this.firstStep) {
        this.constituentsForInceptionDate = this.selectedConstituents
      }
      if (!this.lastStep) {
        this.currentStep++
      }
    },
    goToPreviousStep() {
      if (!this.firstStep) {
        this.currentStep--
      }
    },
    onConstituentsSelectionChanged(constituents) {
      this.selectedConstituents = constituents
    },
    onInceptionDateChanged(payload) {
      this.inceptionYear = payload.year
      this.inceptionMonth = payload.month
    },
  },
  computed: {
    lastStep() {
      return this.currentStep === 2
    },
    firstStep() {
      return this.currentStep === 0
    },
    nextButtonDisabled() {
      return (
        (this.currentStep === 0 && this.selectedConstituents.length < 3) ||
        (this.currentStep == 1 &&
          (this.inceptionYear == 0 || this.inceptionMonth == 0))
      )
    },
  },
}
</script>

<style scoped>
.create-index-layout {
  height: 100%;
  display: grid;
  grid-template-rows: 60px minmax(0, 1fr) 60px;
}
</style>
